import Vue from 'vue';
import Vuex from 'vuex';
// Modules
import snackbar from './modules/snackbar';
import events from './modules/events';
import polls from './modules/polls';
import createPersistedState from 'vuex-persistedstate';

/**
 * Establish namespace live or admin urls
 */
const urlPath = window.location.pathname.split('/');

let namespace = null;
let paths = [];

// if (urlPath.includes('live')) {
//   namespace = urlPath[2];
//   paths = ['namespace', 'token'];
// }
if (urlPath.includes('admin')) {
  paths = [
    'namespace',
    'manager',
    'token',
    'timer',
    'timeInterval',
    'activePoll'
  ];
}

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'agmify-vuex',
      paths: paths
    })
  ],
  state: {
    namespace,
    token: '',
    onlineUsers: [],
    onlineManagers: {},
    loading: false,
    manager: null,
    user: null,
    proxies: [],
    poll: null,
    timer: 0,
    timerInterval: null
  },
  mutations: {
    SET_NAMESPACE(state, payload) {
      state.namespace = payload;
    },
    LOGOUT(state) {
      state.token = '';
      //localStorage.clear();
    },
    LOGIN(state, payload) {
      state.token = payload;
    },
    SET_MANAGER(state, payload) {
      state.manager = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setScrutineer(state, payload) {
      state.user.scrutineer = payload;
    },
    setProxies(state, payload) {
      state.proxies = payload;
    },
    setPoll(state, payload) {
      state.poll = payload;
    },
    setTimer(state, payload) {
      state.timer = payload;
    },
    setTimerInterval(state, payload) {
      state.timerInterval = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SOCKET_ONLINEUSERS(state, payload) {
      state.onlineUsers = payload;
    },
    SOCKET_ONLINE_MANAGERS(state, payload) {
      //console.log('MANAGERS: ', payload);
      state.onlineManagers = payload;
    },
    SET_ONLINE_USERS(state, payload) {
      state.onlineUsers = payload;
    }
  },
  actions: {
    startTimer({ commit, state }, initial) {
      clearInterval(state.timerInterval); // clear any existing
      commit('setTimer', initial);
      const pollTimerInterval = setInterval(() => {
        commit('setTimer', state.timer + 1);
      }, 1000); // every one second increment timer
      commit('setTimerInterval', pollTimerInterval);
    },
    stopTimer({ state }) {
      clearInterval(state.timerInterval);
    }
  },
  modules: {
    snackbar,
    events,
    polls
  }
});
